import { render, staticRenderFns } from "./AgentServiceWindow.vue?vue&type=template&id=dbb6c10a&scoped=true"
import script from "./AgentServiceWindow.vue?vue&type=script&lang=js"
export * from "./AgentServiceWindow.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceWindow.vue?vue&type=style&index=0&id=dbb6c10a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb6c10a",
  null
  
)

export default component.exports